import React from "react";
import Header from "./Header";

import { SearchProvider } from "../context/SearchContext";

export const Layout = ({ children }) => {
  return (
    <div className="container w-[95%] mx-auto">
      <SearchProvider>
        <Header />
        <div className="pt-24">
            {children}
        </div>
      </SearchProvider>
    </div>
  );
};
